function startGame(): void {
  const welcome = document.getElementById("welcome")
  if (welcome != null) {
    welcome.style.display = "none"
    window.engine.startMusic()
  }
}

function toggleInfo(): void {
  const button = document.getElementById("infotoggle")
  const overlay = document.getElementById("overlay")
  const info = document.getElementById("info")
  if (button != null && overlay != null && info != null) {
    if (hasClass(overlay, "hidden")) {
      button.innerText = "Show instructions"
      removeClass(info, "visible")
      addClass(info, "hidden")
      removeClass(overlay, "hidden")
      addClass(overlay, "visible")
    } else {
      button.innerText = "Hide instructions"
      removeClass(overlay, "visible")
      addClass(overlay, "hidden")
      removeClass(info, "hidden")
      addClass(info, "visible")
    }
  }
}

function appendRandomRoomsTotal(amount: number): void {
  const counts = document.getElementById("roomCount")
  if (counts != null && counts.textContent != null) {
    let oldText = counts.textContent.trim()
    if (oldText.length > 0) {
      oldText += ", "
    }
    counts.textContent = oldText + amount.toString()
  }
}

function updateGizmoDisplay(output: string): void {
  const gizmo = document.getElementById("gizmo")
  if (gizmo != null) {
    gizmo.textContent = output
  }
}

function closeLoadingPopup(): void {
  const loadingPopup = window.document.getElementById("loader")
  if (loadingPopup != null) {
    loadingPopup.style.display = "none"
    window.engine.startMusic()
  }
}

function openLoadingPopup(): void {
  const loadingPopup = window.document.getElementById("loader")
  if (loadingPopup != null) {
    loadingPopup.style.display = "flex"
  }
}

function enableStartGameButton(): void {
  const welcomePopup = window.document.getElementById("welcome")
  if (welcomePopup != null && welcomePopup.checkVisibility() == true) {
    const startGameButton = window.document.getElementById(
      "startGameButton"
    ) as HTMLButtonElement
    startGameButton.disabled = false
    startGameButton.innerHTML = "Play Tapestry"
  }
}

function updateSongInfo(title: string): void {
  const songInfo = document.getElementById("songinfo")
  if (songInfo != null) {
    songInfo.innerHTML = title
  }
}

function hasClass(el: HTMLElement | null, className: string): boolean {
  if (el) {
    if (el.classList) return el.classList.contains(className)
    return !!el.className.match(new RegExp("(\\s|^)" + className + "(\\s|$)"))
  }
  return false
}

function addClass(el: HTMLElement | null, className: string): void {
  if (el) {
    if (el.classList) el.classList.add(className)
    else if (!hasClass(el, className)) el.className += " " + className
  }
}

function removeClass(el: HTMLElement | null, className: string): void {
  if (el) {
    if (el.classList) el.classList.remove(className)
    else if (hasClass(el, className)) {
      var reg = new RegExp("(\\s|^)" + className + "(\\s|$)")
      el.className = el.className.replace(reg, " ")
    }
  }
}

function musicIsMuted(): boolean {
  return hasClass(muteButton, "is-hidden")
}

function musicIsStopped(): boolean {
  return hasClass(pauseButton, "is-hidden")
}

function musicVolume(): number {
  if (volumeSlider != null) {
    const volume = (volumeSlider as HTMLInputElement).value
    return parseInt(volume) / 100
  }
  return 0.5
}

function showPauseButton(): void {
  if (playButton != null) {
    removeClass(pauseButton, "is-hidden")
    addClass(playButton, "is-hidden")
  }
}

function showPlayButton(): void {
  if (playButton != null) {
    removeClass(playButton, "is-hidden")
    addClass(pauseButton, "is-hidden")
  }
}

const muteButton = document.getElementById("mute")
const unmuteButton = document.getElementById("unmute")
const playButton = document.getElementById("play")
const pauseButton = document.getElementById("stop")
const volumeSlider = document.getElementById("volumeSlider")

if (volumeSlider != null) {
  volumeSlider.addEventListener("input", (event) => {
    const volume = (event.target as HTMLInputElement).value
    window.engine.setMusicVolume(parseInt(volume) / 100)
  })
}

if (muteButton != null) {
  muteButton.onclick = () => {
    window.engine.muteMusic()
    addClass(muteButton, "is-hidden")
    removeClass(unmuteButton, "is-hidden")
  }
}

if (unmuteButton != null) {
  unmuteButton.onclick = () => {
    window.engine.unmuteMusic()
    addClass(unmuteButton, "is-hidden")
    removeClass(muteButton, "is-hidden")
  }
}

if (playButton != null) {
  playButton.onclick = () => {
    window.engine.startMusic()
    addClass(playButton, "is-hidden")
    removeClass(pauseButton, "is-hidden")
  }
}

if (pauseButton != null) {
  pauseButton.onclick = () => {
    window.engine.pauseMusic()
    addClass(pauseButton, "is-hidden")
    removeClass(playButton, "is-hidden")
  }
}

const startGameButton = document.getElementById("startGameButton")
if (startGameButton != null) {
  startGameButton.addEventListener("click", startGame)
}

const infoToggleButton = document.getElementById("infotoggle")
if (infoToggleButton != null) {
  infoToggleButton.addEventListener("click", toggleInfo)
}

window.addEventListener("keydown", function(e) {
  if(["Space","ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].indexOf(e.code) > -1) {
      e.preventDefault();
  }
}, false);

export {
  appendRandomRoomsTotal,
  closeLoadingPopup,
  enableStartGameButton,
  musicIsMuted,
  musicIsStopped,
  musicVolume,
  openLoadingPopup,
  showPauseButton,
  showPlayButton,
  updateGizmoDisplay,
  updateSongInfo,
}
